import requireAll from "services/requireAll";
import { autobind } from "core-decorators";

let translations = {};

// TODO move all lang files to related modules
requireAll(require.context("./../lang", true, /.+\.json$/)).map((module) => {
  let _lang = translations;

  let _keys = module.path.replace(/(^\.\/|\.json$)/g, "");

  _keys = _keys.split("/");

  _keys.map((_key) => {
    if (!_lang[_key]) {
      _lang[_key] = {};
    }

    _lang = _lang[_key];
  });

  for (const _i in module.data) {
    // noinspection JSUnfilteredForInLoop
    _lang[_i] = module.data[_i];
  }
});

requireAll(require.context("./../", true, /\/lang\/[a-z]+\.json$/)).map((module) => {
  let _lang = translations;

  let _keys = module.path.replace(/(^\.\/|\.json$|lang\/)/g, "");

  _keys = _keys.split("/");

  let _locale = _keys.pop();

  _keys = [
    _locale,
    ..._keys.map((_key) => _key.kebabCase()),
  ];

  _keys.map((_key) => {
    if (!_lang[_key]) {
      _lang[_key] = {};
    }

    _lang = _lang[_key];
  });

  for (const _i in module.data) {
    // noinspection JSUnfilteredForInLoop
    _lang[_i] = module.data[_i];
  }
});

@autobind
/**
 *
 */
export default class Lang {
  static translations = translations;

  /**
   *
   */
  constructor() {
    this.locale = localStorage.getItem("language") || "fa";
  }

  /**
   *
   * @param {String} locale
   * @return {Boolean}
   */
  set(locale) {
    if (localStorage.getItem("language") === locale) {
      return false;
    }

    this.locale = locale;
    localStorage.setItem("data-direction", this.direction);
    localStorage.setItem("language", locale);

    return true;
  }

  /**
   *
   * @return {String}
   */
  get() {
    return this.locale;
  }

  /**
   *
   * @param {String} key
   * @return {String}
   * @private
   */
  _keys(key) {
    try {
      return key.split(".").reduce((prev, cur) => prev[cur], Lang.translations[this.locale]);
    } catch (err) {
      return undefined;
    }
  }

  /**
   *
   * @param {String} string
   * @param {Object} params
   * @return {String}
   * @private
   */
  _params(string, params) {
    params.$mapKeys((value, key) => {
      string = string.replace(new RegExp("\{\{" + key + "\}\}", "g"), value);
    });

    return string;
  }

  /**
   *
   * @param {String} key
   * @param {Object|String} [params={}]
   * @param {String} [def=key]
   * @return {String}
   */
  translate(key, params = {}, def = key) {
    const result = this._keys(key);

    if (result === undefined) {
      return String.isString(params) ? params : def;
    }

    if (Object.isObject(params)) {
      return this._params(result, params);
    }

    return result;
  }

  /**
   *
   * @return {String}
   */
  get direction() {
    switch (this.locale) {
      case "en":
        return "ltr";
      case "fa":
      default:
        return "rtl";
    }
  }
}
